<template lang="pug">
  v-row(justify="center")
    v-dialog(v-model="isVisibleModal", width="600px")
      v-card(id="info-popup-card" class="pa-2")
        v-card-title
          span(class="headline" v-if="id === 'main'") «Главный экран системы»
          span(class="headline" v-else-if="id === 'report'") {{ name }}
          span(class="headline" v-else) База «{{ name }}»
          v-btn(icon class="close-btn" @click="closePopup")
            v-icon close
        v-card-text
          div(v-if="id === 'main'")
            p Вы видите перед собой 7 карточек
            v-img(src="/static/images/main.jpg" class="mb-4")
            strong База «Сигнал»
            p Данная база предназначена для внесения первичной информации поступившей о ребенке.
            strong База «Выявление»
            p В базе «Выявление» имеется Анкета глубокой оценки семьи для детей без ПИН.
            strong База «Дети»
            p В базе «Выявление» имеется Анкета глубокой оценки семьи для детей с ПИН.
            strong База «ИПЗР»
            p После заполнения анкет в базах «Выявлении» и «Дети», система по заданному алгоритму создаст автоматически ИПЗР.
            strong База «Дети в ТЖС»
            p Данная база предназначена для информации о детях, которым присвоен статус ТЖС.
            strong База «Задачи»
            p Данная база содержит все задачи, которые автоматически созданы системой на основе утвержденного ИПЗР и предназначены к исполнению.
            strong «Отчетность»
            p Отчетность по показателям формируется по завершению кейсов и показывается в разрезе районов.
          div(v-if="id === '274f0c5d-2c02-43b2-8d59-77e73b4494ea'")
            p Данная база предназначена для внесения первичной информации поступившей о ребенке.
            v-img(src="/static/images/bd.jpg")
            p Открыв базу «Сигнал» вы увидите список детей на которых поступили сигналы и данная информация была внесена в базу.
            p Для того чтобы добавить новую запись необходимо нажать кнопку «+ Запись» Откроется анкета, которую необходимо заполнить.
          div(v-if="id === '090ec34d-30be-4484-9970-78cc9545f185'")
            p В базе «Выявление» имеется Анкета глубокой оценки семьи для детей без ПИН.
            p Открыв базу вы увидите список детей на которых была создана карточка и информация была внесена.
            p Для того чтобы внести новую запись необходимо нажать кнопку «+ Запись» Откроется анкета, которую необходимо заполнить.
          div(v-if="id === '918bc9db-a779-415f-8b4e-47b978228b17'")
            p В базе «Выявление» имеется Анкета глубокой оценки семьи для детей с ПИН. Отличие базы «Дети» от базы «Выявление» в том, что часть полей заполняются автоматически при подключении из ГРС.
            p
              strong Необходимо подключение через СМЭФ «Тундук».
            p Открыв базу вы увидите список детей на которых создана карточка и информация внесена в базу.
          div(v-if="id === '7a868f4a-cded-49bf-8be2-1e0461423ebe'")
            p(class="mb-0") После заполнения анкет в базах «Выявлении» и «Дети», система по заданному алгоритму создаст автоматически ИПЗР.
            v-img(src="/static/images/record.jpg" class="mb-4")
            p В случае необходимости у сотрудника имеется возможность редактировать мероприятия, редактирование осуществляется с помощью выделения галочками необходимых пунктов.
          div(v-if="id === '9d7c9150-265f-42bc-b2ce-bb706d7408fc'")
            p Данная база предназначена для информации о детях, которым присвоен статус ТЖС. Данная База формируется автоматически из утвержденных ИПЗР. Когда все задачи по ИПЗР будут закрыты, карточка ребенка перестанет отображаться автоматически.
          div(v-if="id === 'issue'")
            p(class="mb-0") Данная база содержит все задачи, которые автоматически созданы системой на основе утвержденного ИПЗР и предназначены к исполнению.
            v-img(src="/static/images/issue.jpg")
            p Задачи формируются из стандартных задач. Сотрудник, ответственный за исполнение Задачи, может только внести отметки об исполнении и не может редактировать саму задачу.
          div(v-if="id === 'report'")
            p Отчетность по показателям формируется по завершению кейсов и показывается в разрезе районов.
        v-card-actions
          v-spacer
          v-btn(color="primary", @click="closePopup") Закрыть
          v-spacer
</template>

<script>
export default {
  name: 'InfoPopup',
  props: {
    isVisibleModal: {
      type: Boolean,
      default: false,
      required: true
    },
    id: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    }
  },
  methods: {
    closePopup() {
      this.$emit('close-info-popup')
    }
  }
}
</script>

<style scoped lang="scss">
#info-popup-card {
  border-radius: 6px;
  .v-btn {
    border-radius: 4px;
  }
  .v-card__title {
    position: relative;
  }
  .close-btn {
    position: absolute;
    top: 0;
    right: 0;
    width: 46px;
    height: 46px;
    border-radius: 25%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/DataBase/Common/InfoPopup.vue